module.exports = __webpack_public_path__ + "img/metal desplegado.110a335b.jpg";